class Video {
  init() {
    const videos = document.querySelectorAll("#video");
    const playButtons = document.querySelectorAll(".media__play");
    const fullButtons = document.querySelectorAll(".media__full-screen");

    playButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        const videoElement = btn.previousElementSibling;
        videoElement.play();
        videoElement.style.cursor = "pointer";
        btn.style.display = "none";
      });
    });

    videos.forEach(video => {
      video.addEventListener("click", () => {
        const btn = video.nextElementSibling;
        btn.style.display = "flex";
        video.pause();
        video.style.cursor = "default";
      });
    });

    fullButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        const videoWrapper = btn.parentElement;
        const body = document.querySelector("body");
        videoWrapper.classList.toggle("media__full");
        body.style.overflow = videoWrapper.classList.contains("media__full") ? "hidden" : "scroll";

        window.addEventListener("keydown", e => {
          if (e.keyCode === 27 && videoWrapper.classList.contains("media__full")) {
            videoWrapper.classList.remove("media__full");
            body.style.overflow = "scroll";
          }
        });
      });
    });
  }
}

export default Video;
